import axiosInstance from "./axiosInstance";

export const fetchFleetPerformanceMetadata = async (fleetId, filters={startDate: null, endDate: null}) => {
    const queryParams = new URLSearchParams();
    if (filters?.startDate) queryParams.append('start', filters.startDate);
    if (filters?.endDate) queryParams.append('end', filters.endDate);
    return await axiosInstance.get(`/fleets/${fleetId}/performance/metadata`, {
        params: queryParams,
    });
}

export const fetchFleetFuelConsumption = async (fleetId, filters={startDate: null, endDate: null}) => {
    const queryParams = new URLSearchParams();
    if (filters?.startDate) queryParams.append('start', filters.startDate);
    if (filters?.endDate) queryParams.append('end', filters.endDate);

    return await axiosInstance.get(`/fleets/${fleetId}/performance/fuelconsumption`, {
        params: queryParams,
    });
}

export const fetchFleetRemainingFuel = async (fleetId, filters={startDate: null, endDate: null}) => {
    const queryParams = new URLSearchParams();
    if (filters?.startDate) queryParams.append('start', filters.startDate);
    if (filters?.endDate) queryParams.append('end', filters.endDate);

    return await axiosInstance.get(`/fleets/${fleetId}/performance/fuelremaining`, {
        params: queryParams,
    });
}

export const fetchFleetMainEnginePower = async (fleetId, filters={startDate: null, endDate: null}) => {
    const queryParams = new URLSearchParams();
    if (filters?.startDate) queryParams.append('start', filters.startDate);
    if (filters?.endDate) queryParams.append('end', filters.endDate);

    return await axiosInstance.get(`/fleets/${fleetId}/performance/mainenginepower`, {
        params: queryParams,
    });
}

export const fetchFleetSFOCPower = async (fleetId, filters={startDate: null, endDate: null}) => {
    const queryParams = new URLSearchParams();
    if (filters?.startDate) queryParams.append('start', filters.startDate);
    if (filters?.endDate) queryParams.append('end', filters.endDate);

    return await axiosInstance.get(`/fleets/${fleetId}/performance/sfocefficiency`, {
        params: queryParams,
    });
}